import {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from 'react'

import { PlayerStore } from './player-store'

const PlayerStoreContext = createContext<PlayerStore | null>(null)

// per-instance：每个 PlayerProvider 经 useState 工厂只创建一个独立 PlayerStore，
// 不同 Provider 实例彼此隔离，同页多 player 互不干扰。
const PlayerProvider = ({ children }: { children: ReactNode }) => {
  const [store] = useState(() => new PlayerStore())
  return <PlayerStoreContext.Provider value={store}>{children}</PlayerStoreContext.Provider>
}

const usePlayerStore = () => {
  const store = useContext(PlayerStoreContext)
  if (!store) {
    throw new Error('usePlayerStore must be used within a PlayerProvider')
  }
  return store
}

export { PlayerProvider, usePlayerStore }
